import { useCallback, useState } from "react";
import type { Supplier } from "@/shared/types/supplier.types";
import { useSuppliersMutations } from "../../hooks/useSupplierMutations";

export const useSuppliersDrawerActions = () => {
  const { deleteSupplierMutation } = useSuppliersMutations();

  const [formDrawerOpen, setFormDrawerOpen] = useState(false);
  const [supplierToEdit, setSupplierToEdit] = useState<Supplier | undefined>(undefined);

  const openCreateForm = useCallback(() => {
    setSupplierToEdit(undefined);
    setFormDrawerOpen(true);
  }, []);

  const openEditForm = useCallback((supplier: Supplier) => {
    setSupplierToEdit(supplier);
    setFormDrawerOpen(true);
  }, []);

  const closeFormDrawer = useCallback(() => {
    setFormDrawerOpen(false);
    setSupplierToEdit(undefined);
  }, []);

  const deleteSupplier = useCallback(async (supplier: Supplier) => {
    await deleteSupplierMutation.mutateAsync(supplier.id);
  }, [deleteSupplierMutation]);

  const resetAll = useCallback(() => {
    setFormDrawerOpen(false);
    setSupplierToEdit(undefined);
  }, []);

  return {
    formDrawerOpen,
    supplierToEdit,
    openCreateForm,
    openEditForm,
    closeFormDrawer,
    deleteSupplier,
    isDeleting: deleteSupplierMutation.isPending,
    resetAll,
  };
};
